<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
    <template v-slot:main>
      <head-utils title="Pesquisa de Propostas"/>
      <breadcrumb :items="[{label: 'Pesquisar Propostas', path: '/proposals'}]"/>

      <form @submit.prevent.stop="submit">
        <ibox>
          <template v-slot:title v-if="!$appUtils.isMobile()">
            <h5>Filtros de Pesquisa</h5>
          </template>

          <template v-slot:content>
            <div v-if="!$appUtils.isMobile() || filterMode" class="container-fluid-grid">
              <div class="form-row">
                <div class="col-3 col-md-1 form-group">
                  <label for="proposalSearchNumber">Número</label>
                  <input id="proposalSearchNumber"
                         maxlength="8"
                         type="text"
                         class="form-control form-control-sm t-r"
                         v-model="search_params.number"/>
                </div>
                <div class="col-9 col-md-3 form-group">
                  <label for="proposalSearchCity">Cidade</label>
                  <input id="proposalSearchCity" maxlength="50" type="text" class="form-control form-control-sm"
                         v-model="search_params.city"/>
                </div>
                <div class="col-9 col-md-3 form-group">
                  <label for="proposalSearchProduct">Produto</label>
                  <select id="proposalSearchProduct" class="form-control form-control-sm"
                          v-model="search_params.product_id">
                    <option selected value="">[SELECIONE]</option>
                    <optgroup v-for="c in categories" :label="c.name">
                      <option v-for="p in products"
                              v-if="p.product_category_id === c.id"
                              :key="p.id"
                              :value="p.id">{{ p.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
                <div class="col-3 col-md-1 form-group">
                  <label for="proposalSearchHarvest">Safra</label>
                  <input id="proposalSearchHarvest"
                         maxlength="4"
                         type="text"
                         class="form-control form-control-sm t-r"
                         v-model="search_params.harvest"/>
                </div>
                <div class="col-md-4 form-group">
                  <label for="proposalSearchBroker">Corretor</label>
                  <input id="proposalSearchBroker" type="text" class="form-control form-control-sm"
                         v-model="search_params.broker"/>
                </div>
              </div>
              <div class="form-row">
                <div class="col-6 col-md-4 form-group">
                  <label for="proposalSearchSeller">Vendedor</label>
                  <input id="proposalSearchSeller"
                         type="text"
                         class="form-control form-control-sm"
                         v-model="search_params.seller"/>
                </div>
                <div class="col-6 col-md-4 form-group">
                  <label for="proposalSearchBuyer">Comprador</label>
                  <input id="proposalSearchBuyer"
                         type="text"
                         class="form-control form-control-sm"
                         v-model="search_params.buyer"/>
                </div>
                <div class="col-6 col-md-2 form-group">
                  <label for="proposalSearchStart">Criado entre</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalSearchStart"
                           v-model="search_params.start"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-2 form-group">
                  <label for="proposalSearchEnd">&nbsp;</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalSearchEnd"
                           v-model="search_params.finish"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-6 col-md-2 form-group">
                  <label for="proposalSearchStartBilling">Faturar entre</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalSearchStartBilling"
                           v-model="search_params.start_billed"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" col-6 col-md-2 form-group">
                  <label for="proposalSearchFinishBilling">&nbsp;</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalSearchFinishBilling"
                           v-model="search_params.billed_finish"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-md-2 form-group">
                  <label for="proposalSearchStartPaid">Pagamento entre</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalSearchStartPaid"
                           v-model="search_params.start_paid"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" col-6 col-md-2 form-group">
                  <label for="proposalSearchFinishPaid">&nbsp;</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalSearchFinishPaid"
                           v-model="search_params.paid_finish"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-md-2 form-group">
                  <label for="proposalSearchStatusPaid">Situação cobrança</label>
                  <select id="proposalSearchStatusPaid" class="form-control form-control-sm"
                          v-model="search_params.paid_status">
                    <option selected value="all" title="Todos os estados">Indiferente</option>
                    <option value="open" title="Possui mas não foi pago">Em aberto</option>
                    <option value="close" title="Possui alguma cobrança e alguma cobrança foi paga">Quitado</option>
                    <option value="not_billed" title="Não possui cobrança">Não Faturado</option>
                  </select>
                </div>
                <div class="col-6 col-md-2 form-group">
                  <label for="proposalSearchType">Adendo</label>
                  <select id="proposalSearchType" class="form-control form-control-sm" v-model="search_params.type">
                    <option selected value="all">Indiferente</option>
                    <option value="in">Com Adendo</option>
                    <option value="out">Sem Adendo</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="col-4 col-md-2 form-group">
                  <label for="proposalIsBillable">Gera Comissão</label>
                  <select id="proposalIsBillable" class="form-control form-control-sm"
                          v-model="search_params.is_billable">
                    <option selected value="all">Todos</option>
                    <option value="billing">Gera Comissão</option>
                    <option value="not_billing">Não Gera Comissão</option>
                  </select>
                </div>
                <div class="col-4 col-md-2 form-group">
                  <label for="proposalPriceMode">Modalidade preço</label>
                  <select id="proposalPriceMode" class="form-control form-control-sm"
                          v-model="search_params.price_type">
                    <option selected value="all">Todos</option>
                    <option value="value_undefined">A fixar</option>
                    <option value="value_defined">Definido</option>
                  </select>
                </div>
                <div class="col-4 col-md-2 form-group">
                  <label for="proposalSearchFreightType">Frete</label>
                  <select id="proposalSearchFreightType"
                          required
                          class="form-control form-control-sm"
                          v-model="search_params.freight_type">
                    <option selected value="all">Todos</option>
                    <option v-for="ft in freight_types"
                            :key="ft.code"
                            :value="ft.code">{{ft.label}}</option>
                  </select>
                </div>
                <div class="col-4 col-md-2 form-group">
                  <label for="proposalSearchShipmentType">Embarque</label>
                  <input id="proposalSearchShipmentType"
                         type="text"
                         class="form-control form-control-sm"
                         v-model="search_params.shipment_type"/>
                </div>
              </div>
            </div>

            <div v-if="$appUtils.isMobile() && !filterMode">
              <div v-for="p in search.entries" class="list-card">
                <span class="number">{{ p.number }}</span>
                <span class="date">{{ p.created_at | formatDate }}</span>
                <div class="product">
                  <span><svg-icon icon="weight"/> {{ p.quantity }}</span>
                  <span class="f-w-700">{{ p.product.name }}</span>
                  <span>R$ {{ p.price | formatMoney }}</span>
                </div>
                <span class="seller">{{ p.group_seller.name }}</span>
                <span class="buyer">{{ p.group_buyer.name }}</span>
                <svg-icon class="to" icon="arrow-right"/>
                <span class="harvest">Safra {{ p.harvest }}</span>

                <div class="act">
                  <router-link :to="{path: `/proposals/${p.id}/edit`}"
                               title="Editar contrato"
                               class="btn btn-sm">
                    <svg-icon icon="pencil-alt"/>
                  </router-link>
                  <button type="button"
                          class="btn btn-sm"
                          title="Ver PDF"
                          @click="viewPdf(p)">
                    <svg-icon icon="search"/>
                  </button>
                  <button type="button"
                          class="btn btn-sm"
                          title="Download PDF"
                          @click="downloadPdf(p)">
                    <svg-icon :class="{'refresh rotate-1-seg': downloadingIds[p.id]}"
                              :icon="downloadingIds[p.id] ? 'sync' : 'cloud-download-alt'"/>
                  </button>
                  <router-link :to="{path: '/proposals/new', query: {clone: p.id}}"
                               title="Clonar contrato"
                               class="btn btn-sm">
                    <svg-icon icon="clone"/>
                  </router-link>
                </div>
              </div>
            </div>

            <div ref='end_grid' v-if="$appUtils.isMobile()">

              <FabMenuCrud :is-open="!filterMode && isOpenFabMenu"
                           url-new="/proposals/new"
                           v-if="!filterMode"
                           @onExpand="isOpenFabMenu = !isOpenFabMenu"
                           @onFilter="(is) => {
                                         filterMode = is;
                                         isOpenFabMenu = false;
                                         }"/>

              <div class="t-c">
                <svg-icon v-if="searching" icon="sync" class="refresh load-more-crud"/>
              </div>
            </div>
          </template>

          <template v-slot:footer>
            <div class="row" v-if="filterMode || !$appUtils.isMobile()">
              <div class="col-sm-12 t-r">
                                    <span class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                        <button type="button" @click="resetAll" class="btn btn-secondary btn-sm"><svg-icon
                                            icon="sync"/> Limpar</button>
                                        <button v-if="isAdminProfile || isBackofficeProfile"
                                                type="button"
                                                :disabled="downloadingCsv"
                                                class="btn btn-theme-1-six btn-sm"
                                                @click="downloadCsv">
                                          <svg-icon :class="{'refresh rotate-1-seg': downloadingCsv}"
                                                    :icon="downloadingCsv ? 'sync' : 'file-excel'"/> {{
                                            downloadingCsv ? 'Baixando...' : 'Baixar Excel'
                                          }}
                                        </button>
                                        <button type="button" @click="modeBilling = !modeBilling" class="btn btn-sm"
                                                :class="{'btn-info': !modeBilling, 'btn-danger': modeBilling}">
                                            <svg-icon
                                                :icon="modeBilling ? 'times' : 'check'"/> {{ modeBilling ? 'Fechar' : 'Solicitar Fatura' }}
                                        </button>
                                        <router-link to="/proposals/new" class="btn btn-dark btn-sm"><svg-icon
                                            icon="plus"/> Criar Novo</router-link>
                                        <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                                    </span>
              </div>
            </div>
            <transition name="tab" mode="out-in">
              <div class="row" v-if="modeBilling">
                <div class="col-12 form-group">
                  <label>Contratos Selecionados</label>
                  <transition-group name="p-anim" tag="div" class="proposals-container">
                                            <span
                                                v-for="k in Object.keys(proposalsToBilling).sort((a,b) => b.id - a.id)"
                                                :key="k">
                                                {{ proposalsToBilling[k].number }} <span
                                                @click="addRemProp2Bill(proposalsToBilling[k])"><svg-icon icon="times"/></span>
                                            </span>
                    <span v-if="Object.keys(proposalsToBilling).length > 1"
                          key="clearBillProposals"
                          @click="remAllToBilling"
                          class="clear"><span><svg-icon icon="times"/></span></span>
                  </transition-group>
                  <small>Selecione os contratos que deseja solicitar faturamento</small>
                  <div class="t-r">
                    <button :disabled="Object.keys(proposalsToBilling).length === 0"
                            @click="showConfirmationBilling = true"
                            type="button"
                            class="btn btn-primary btn-sm">
                      <svg-icon icon="envelope"/>
                      Solicitação Faturamento
                    </button>
                  </div>
                </div>
              </div>
            </transition>

            <ModalPermissionBilling :show-modal="showConfirmationBilling"
                                    :proposals="proposalsToBillingList"
                                    @onClose="showConfirmationBilling = false"/>

            <div class="row" v-if="$appUtils.isDesktop()">
              <div class="col-sm-12">
                <br/>
                <Pagination
                    :page_size="search.per_page"
                    :current_page="search.current_page"
                    :total_entries="search.total_entries"/>

                <Loading :visible="searching"/>
                <table class="table table-hover table-striped table-sm table-bordered">
                  <thead class="thead-dark thead-center">
                  <tr>
                    <th v-if="modeBilling" class="t-c" style="width: 40px">
                      <button type="button" @click="addAllProp2Bill" class="btn btn-xs"
                              :class="{'btn-danger': !hasNotChecked, 'btn-theme-1': hasNotChecked}">
                        <svg-icon :icon="hasNotChecked ? 'check' : 'times'"/>
                      </button>
                    </th>
                    <th style="width: 90px">DATA</th>
                    <th style="width: 80px">NÚMERO</th>
                    <th>VENDEDOR</th>
                    <th>COMPRADOR</th>
                    <th>PRODUTO</th>
                    <th>FATURAR EM</th>
                    <th style="width: 110px">QUANTIDADE</th>
                    <th style="width: 80px">PREÇO</th>
                    <th style="width: 160px">COMIS. AGRISOY</th>
                    <th v-if="isAdminProfile || isBrokerProfile" style="width: 160px">COMIS. CORRETOR</th>
                    <th style="width: 80px">SAFRA</th>
                  </tr>
                  </thead>
                  <tbody v-if="search && search.entries">
                  <tr v-for="p in search.entries" :key="p.id" class="line-item"
                      :class="{'cancel c-red': p.canceled, 'value-undefined': p.price_type === 'value_undefined'}">
                    <td v-if="modeBilling" class="t-c">
                      <button v-if="!p.canceled" type="button" @click="addRemProp2Bill(p)" class="btn btn-xs"
                              :class="{'btn-danger': proposalsToBilling[p.id], 'btn-theme-1': !proposalsToBilling[p.id]}">
                        <svg-icon :icon="proposalsToBilling[p.id] ? 'minus-circle' : 'plus'"/>
                      </button>
                    </td>
                    <td class="v-m c-p t-c" @click="edit(p.id)">{{ p.created_at | formatDate }}</td>
                    <td class="v-m c-p t-c f-w-700" @click="edit(p.id)">{{ p.number }}</td>
                    <td class="v-m c-p f-w-700 ellipsis p-r o-h" @click="edit(p.id)" :title="p.seller.name">
                      {{ p.group_seller.name }}
                      <div class="actions">
                        <button type="button"
                                class="btn btn-secondary btn-xs"
                                title="Copiar"
                                @click="copyClipboard($event, p.seller)">
                          <svg-icon icon="copy"/>
                        </button>
                      </div>
                    </td>
                    <td class="v-m c-p f-w-700 ellipsis p-r o-h" @click="edit(p.id)" :title="p.buyer.name">
                      {{ p.group_buyer.name }}
                      <div class="actions">
                        <button type="button"
                                class="btn btn-secondary btn-xs"
                                title="Copiar"
                                @click="copyClipboard($event, p.buyer)">
                          <svg-icon icon="copy"/>
                        </button>
                      </div>
                    </td>
                    <td class="v-m c-p ellipsis" @click="edit(p.id)">{{ p.product.name }}</td>
                    <td class="v-m c-p t-c ellipsis" @click="edit(p.id)">{{ p.billing_date | formatDate }}</td>
                    <td class="v-m c-p t-r" @click="edit(p.id)">{{ p.quantity }}</td>
                    <td class="v-m c-p t-r" @click="edit(p.id)">{{ p.price | formatMoney }}</td>
                    <td class="v-m c-p t-r" @click="edit(p.id)">{{ p.commission | formatMoney }}</td>
                    <td v-if="isAdminProfile || isBrokerProfile" @click="edit(p.id)" class="v-m c-p t-c"
                        :title="commissionTitle(p)">
                      {{ commissionLabel(p) }}
                    </td>
                    <td class="v-m c-p t-c p-r o-h">
                      {{ p.harvest }}
                      <div class="actions btn-group btn-group-xs">
                        <button type="button"
                                class="btn btn-primary btn-xs"
                                title="Ver PDF"
                                @click="viewPdf(p)">
                          <svg-icon icon="search"/>
                        </button>
                        <button type="button"
                                class="btn btn-secondary btn-xs"
                                title="Download PDF"
                                @click="downloadPdf(p)">
                          <svg-icon :class="{'refresh rotate-1-seg': downloadingIds[p.id]}"
                                    :icon="downloadingIds[p.id] ? 'sync' : 'cloud-download-alt'"/>
                        </button>
                        <router-link :to="{path: '/proposals/new', query: {clone: p.id}}"
                                     title="Clonar contrato"
                                     class="btn btn-info btn-xs">
                          <svg-icon icon="clone"/>
                        </router-link>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <Pagination
                    :page_size="search.per_page"
                    :current_page="search.current_page"
                    :total_entries="search.total_entries"/>
              </div>
            </div>
          </template>
        </ibox>
      </form>
    </template>
    <template v-slot:footer>
      <BottomMenuMob v-if="$appUtils.isMobile() && !filterMode"/>
    </template>
  </DefaultTmpl>
</template>

<script>
import Pagination from '@/components/Pagination'
import CRUDSearch from '@/mixins/CRUDSearch'
import {createNamespacedHelpers} from 'vuex'
import BottomMenuMob from "../../components/particles/BottomMenuMob";
import FabMenuCrud from "../../components/particles/FabMenuCrud";
import Loading from "../../components/particles/Loading";
import ModalPermissionBilling from "./ModalPermissionBilling";
import {formatDate, formatMoney} from "@/utils/Utils";

const {mapGetters, mapActions} = createNamespacedHelpers('products');
const {mapGetters: mapGettersUsers} = createNamespacedHelpers('users');

let timeOut = null;

export default {
  name: "ProposalsSearch",
  components: {
    FabMenuCrud,
    Pagination,
    BottomMenuMob,
    Loading,
    ModalPermissionBilling
  },
  mixins: [
    CRUDSearch.mount('proposals')
  ],
  data() {
    return {
      isOpenFabMenu: false,
      selectedId: null,
      stileActions: {},
      downloadingIds: {},
      downloadingCsv: false,
      modeBilling: false,
      proposalsToBilling: {},
      showConfirmationBilling: false,
      freight_types: [],
    }
  },
  methods: {
    ...mapActions(['loadAll', 'loadCategories']),
    createSearchParams() {
      return {
        product_id: "",
        paid_status: 'all',
        type: 'all',
        is_billable: 'all',
        price_type: 'all',
        freight_type: 'all',
      }
    },
    getIntersectItemListener() {
      return this.$refs.end_grid;
    },
    viewPdf(e) {
      const params = new URLSearchParams({
        url: `/v1/proposals/view/pdf?id=${e.id}&d=attachment`,
        name: `Confirmação de Negócio - ${e.number}.pdf`
      });
      this.$router.push({path: `/pdf-viewer?${params.toString()}`})
    },
    downloadPdf(e) {
      this.$set(this.downloadingIds, e.id, true);

      this.$appUtils.downloadPdf(`/v1/proposals/view/pdf?id=${e.id}&d=attachment`, `Confirmação de Negócio - ${e.number}.pdf`)
          .catch(err => {
            this.$snotify.error(this.$t('common.downloadPdfError'), this.$appStorage.getUser().name);
            console.error(err);
          })
          .finally(() => setTimeout(() => this.$set(this.downloadingIds, e.id, false), 1000));
    },
    async downloadCsv() {

      this.downloadingCsv = true;

      const params = Object
          .keys(this.search_params)
          .reduce((p, k) => {
            p.set(k, this.search_params[k])
            return p
          }, new URLSearchParams())
      params.delete('page')

      try {
        await this.$appUtils.downloadCsv(`/v1${this.$router.currentRoute.path}.csv?${params.toString()}`, `Propostas ${this.$appUtils.formatDate(new Date())}.csv`)
      } catch (err) {
        this.$snotify.error(this.$t('common.downloadCsvError'), this.$appStorage.getUser().name);
      } finally {
        this.downloadingCsv = false;
      }
    },
    copyClipboard(e, customer) {
      e.preventDefault();
      e.stopPropagation();
      const el = document.createElement('textarea');
      const str = [customer.name];

      if (customer.document) str.push('(', this.$appUtils.formatDocument(customer.document), ') ');
      if (customer.address) str.push(customer.address);
      if (customer.address_number) str.push(customer.address_number);
      if (customer.postal_code) str.push(' - CEP ', this.$appUtils.formatPostalCode(customer.postal_code));
      if (customer.city) str.push(customer.city.name, '/', customer.city.state_acronym);


      el.value = str.join(' ');
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.$snotify.info('Copiado para o clipboard com sucesso.', this.$appStorage.getUser().name);
    },
    addRemProp2Bill(p) {
      if (p.canceled) return false;

      if (this.proposalsToBilling[p.id]) this.$delete(this.proposalsToBilling, p.id);
      else {
        if (this.proposalsToBillingList.filter(prop => p.group_seller.id !== prop.group_seller.id).length > 0) {
          if (timeOut) clearTimeout(timeOut);

          timeOut = setTimeout(() => {
            this.$snotify.info('Você está tentando selecionar contratos com vendedores de diferentes grupos.', this.$appStorage.getUser().name);
            timeOut = null;
          }, 50);

        } else {
          this.$set(this.proposalsToBilling, p.id, p);
        }
      }
    },
    addAllProp2Bill() {
      const has = this.hasNotChecked;

      this.search.entries.forEach(p => {
        if ((has && !this.proposalsToBilling[p.id]) || (!has && this.proposalsToBilling[p.id]))
          this.addRemProp2Bill(p);
      });
    },
    remAllToBilling() {
      Object.keys(this.proposalsToBilling).forEach(k => this.addRemProp2Bill(this.proposalsToBilling[k]))
    },
    resetAll() {
      this.remAllToBilling();
      this.modeBilling = false;
      this.reset();
    },
    commissionLabel({commissions}) {
      if (commissions) {
        return `${commissions.filter(c => !c.paid).length > 0 ? 'Não ' : ''}Paga`
      }

      return ' - '
    },
    commissionTitle({commissions}) {
      const isBroker = this.isBrokerProfile;

      if (commissions) {
        return commissions.reduce((arr, v) => {
          let str = `${v.name}: ${formatMoney(v.value)} em ${formatDate(v.paid_at)}`
          if (isBroker) str = `${v.name} em ${formatDate(v.paid_at)}`

          return [...arr, str]
        }, []).join('\n')
      }

      return null
    },
    loadFreightTypes() {
      this.$appHttp.get('/v1/proposals/load_freight_types')
          .then(({data}) => this.freight_types = data)
          .catch(err => {
            this.$snotify.warning('Aconteceu algum problema ao tentar carregar os tipos de frete.', this.$appStorage.getUser().name);
            console.error('Load freight types error.', err);
          });
    }
  },
  computed: {
    ...mapGettersUsers(['userSession']),
    ...mapGetters({products: 'all', categories: 'categories'}),
    hasNotChecked() {
      return this.search.entries.filter(e => !this.proposalsToBilling[e.id]).length > 0;
    },
    proposalsToBillingList() {
      return Object.keys(this.proposalsToBilling).map(k => this.proposalsToBilling[k]);
    },
    isAdminProfile() {
      return 'profile' in (this.userSession || {}) && /^admin/.test(this.userSession.profile)
    },
    isBackofficeProfile() {
      return 'profile' in (this.userSession || {}) && /^backoffice/.test(this.userSession.profile)
    },
    isBrokerProfile() {
      return 'profile' in (this.userSession || {}) && /^broker/.test(this.userSession.profile)
    }
  },
  created() {
    this.loadCategories();
    this.loadFreightTypes();
    this.loadAll();
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/variables";

.proposals-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  border: 1px solid rgb(206, 212, 218);
  padding: 2px 2px 4px;
  border-radius: 5px;
  min-height: 29px;

  > span {
    background-color: $theme_color_one;
    color: #fff;
    display: inline-block;
    border-radius: .7em;
    padding-left: 10px;
    padding-right: 10px;
    font-size: .8em;
    margin-top: 2px;
    margin-right: 5px;

    span {
      display: inline-block;
      cursor: pointer;

      svg {
        width: 1em;
        height: 1em;
        margin-top: -3px;
      }

      &:hover svg {
        color: #000;
      }
    }

    &.clear {
      cursor: pointer;
      background-color: red;
      padding-left: 5px;
      padding-right: 5px;

      &:hover {
        color: #000;
      }
    }
  }
}

.list-card {
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 20px 1fr;
  grid-template-rows: auto;
  grid-template-areas: "number number date"  "product product product" "seller to buyer" "harvest harvest act";
  grid-gap: 5px;
  font-size: .8em;
  padding: 5px;

  &:not(:first-child) {
    border-top: 1px solid #e7eaec;
  }

  .number {
    grid-area: number;
  }

  .date {
    grid-area: date;
    text-align: right;
  }

  .product {
    grid-area: product;
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
      width: 1em;
      height: 1em;
      color: $theme_color_one;
      margin-top: -4px;
    }
  }

  .seller {
    grid-area: seller;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: bold;
  }

  .buyer {
    grid-area: buyer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: right;
    font-weight: bold;
  }

  .to {
    grid-area: to;
    text-align: center;
    width: 10px;
    height: 10px;
    color: $theme_color_one;
  }

  .harvest {
    grid-area: harvest;
  }

  .act {
    text-align: right;

    .btn {
      background-color: #e5e5e5;

      svg {
        color: #000;
      }
    }

    .btn:not(:last-child) {
      margin-right: 5px;
    }
  }
}

.cancel {
  text-decoration: line-through;
}

.value-undefined {
  color: #cb5d00;
}

.p-anim-enter-active, .p-anim-leave-active {
  transition: all .3s ease-in-out;
}

.p-anim-enter, .p-anim-leave-to {
  opacity: 0;
  transform: scale(.1);
}
</style>
